<template>
  <div>Supplier Order Create View</div>
</template>

<script>
export default {
  name: 'SupplierOrderCreate',
};
</script>
